import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AlertUser } from 'src/app/models/alert';
import { PencilPillComponent } from 'src/app/standalones/components/pencil-pill/pencil-pill.component';
import { SpaceUsersTooltipContentComponent } from 'src/app/sessions/spaces-view/spaces-list/space-users-tooltip-content/space-users-tooltip-content.component';
import { UiModule } from 'src/app/ui/ui.module';

/**
 * One "label → user pills" row of the alert Related section: the first user as a
 * pill, the rest collapsed into a `+n` pill whose tooltip lists them. Shared by
 * the event and space related components, which differ only in labels and data.
 */
@Component({
  selector: 'app-related-user-row',
  templateUrl: './related-user-row.component.html',
  styleUrls: ['./related-user-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, UiModule, PencilPillComponent, SpaceUsersTooltipContentComponent],
})
export class RelatedUserRowComponent {
  /**
   * Already-translated row label, e.g. `[label]="'Organizer' | translate"`. Consumers
   * translate it so ngx-translate-extract can see the literal key — the extractor
   * cannot follow a key through a variable.
   */
  @Input() label = '';

  /**
   * Split once on assignment rather than in the template — a `slice()` call in a
   * binding re-runs on every change-detection pass and hands `*ngIf` a new array
   * reference each time.
   */
  @Input() set users(users: (AlertUser | null)[]) {
    const existingUsers = users.filter((user): user is AlertUser => !!user);
    this.firstUser = existingUsers[0] ?? null;
    this.remainingUsers = existingUsers.slice(1);
  }

  firstUser: AlertUser | null = null;
  remainingUsers: AlertUser[] = [];
}
